import b_ from 'b_';
import React from 'react';
import { observer } from 'mobx-react';

import { WidgetConfigurationProps } from 'controls/designer/features/widgets/widgetConfig';
import { Section } from 'controls/react/layout/section';
import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { AntInput } from 'controls/react/ant/antInput';
import { BoxView } from 'controls/react/layout/boxView';
import {ExportWidgetConfig, ExportWidgetType} from 'controls/designer/features/widgets/export/types';
import { ExportWidgetStore } from 'controls/designer/features/widgets/export/store';
import { i18n } from './localization';

const b = b_.with('export-widget-configuration');

class Configuration extends React.Component<WidgetConfigurationProps<ExportWidgetConfig>> {
	store: ExportWidgetStore;

	constructor(props: WidgetConfigurationProps<ExportWidgetConfig>) {
		super(props);
		this.store = new ExportWidgetStore({
			config: props.config,
			setValidator: props.setValidator,
			disableCreation:
				props.designerStore.customData.some((x) => x.widgetConfig?.type == ExportWidgetType) &&
				this.props.mode == 'create',
		});
	}

	render() {
		return (
			<Section containerClass={b()}>
				{this.store.widgetExists && <BoxView type={'info-2'}>{i18n('Widget already exists on dashboard')}</BoxView>}
				<Section
					title={i18n('General')}
					appearance={'frame-top-only'}
					contentPadding={true}
					childrenPadding={true}
					disabled={this.store.widgetExists}
				>
					<FormEntryNew label={i18n('Name')} model={this.store.model} modelField={'title'}>
						<AntInput />
					</FormEntryNew>
				</Section>
			</Section>
		);
	}
}

export default observer(Configuration);
